import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { acceptRequest, deleteRequest } from "../../functions/user";
import "./style.css";

export default function FriendshipNotification({ notification, onClose, onAction }) {
  const { user } = useSelector((state) => ({ ...state }));
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onClose();
      }, 300);
    }, 8000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleAccept = async () => {
    setLoading(true);
    const res = await acceptRequest(notification.from?._id, user.token);
    if (res === "ok") {
      handleClose();
      if (onAction) onAction("accepted");
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    const res = await deleteRequest(notification.from?._id, user.token);
    if (res === "ok") {
      handleClose();
      if (onAction) onAction("deleted");
    }
    setLoading(false);
  };

  const getMessage = () => {
    switch (notification.type) {
      case "friend_request":
        return `${notification.from?.first_name} ${notification.from?.last_name} sent you a friend request`;
      case "friend_accepted":
        return `${notification.from?.first_name} ${notification.from?.last_name} accepted your friend request`;
      case "request_cancelled":
        return `${notification.from?.first_name} ${notification.from?.last_name} cancelled their friend request`;
      case "unfriended":
        return `${notification.from?.first_name} ${notification.from?.last_name} removed you from friends`;
      case "started_following":
        return `${notification.from?.first_name} ${notification.from?.last_name} started following you`;
      default:
        return notification.message || "";
    }
  };

  return (
    <div className={`friendship_notification ${isVisible ? "show" : "hide"}`}>
      <div className="friendship_notification_content">
        <Link
          to={`/profile/${notification.from?.username}`}
          className="friendship_notification_left"
        >
          <img
            src={notification.from?.picture}
            alt=""
            className="friendship_notification_img"
          />
        </Link>
        <div className="friendship_notification_info">
          <div className="friendship_notification_message">
            {getMessage()}
          </div>
          <div className="friendship_notification_time">Just now</div>
        </div>
        <button
          className="friendship_notification_close"
          onClick={handleClose}
        >
          <i className="exit_icon"></i>
        </button>
      </div>
      {notification.type === "friend_request" && (
        <div className="friendship_notification_actions">
          <button
            className="friendship_notification_btn primary"
            onClick={handleAccept}
            disabled={loading}
          >
            {loading ? "..." : "Accept"}
          </button>
          <button
            className="friendship_notification_btn secondary"
            onClick={handleDelete}
            disabled={loading}
          >
            Delete
          </button>
        </div>
      )}
      {notification.type === "friend_accepted" && (
        <div className="friendship_notification_actions">
          <Link
            to={`/profile/${notification.from?.username}`}
            className="friendship_notification_btn primary"
            onClick={handleClose}
          >
            View Profile
          </Link>
        </div>
      )}
    </div>
  );
}
